var categoryActive = false;

$('.js-list-category').on('click',function(){

  if(!$('.js-list-category').hasClass('active')){
    // 初回
    $(this).addClass('active');
    const num = $('.js-list-category').index($(this));

    const targetH = $('.js-category-inner').eq(num).outerHeight(true);
    $('.js-category-box').eq(num).height(targetH);
    $('.js-category-box').eq(num).addClass('show');
  } else {


    if($(this).hasClass('active') || categoryActive){
      return false;
    }
    
    categoryActive = true;

    const nownum = $('.js-list-category').index($('.js-list-category.active'));
    const num = $('.js-list-category').index($(this));

    $('.js-list-category').removeClass('active');
    $('.js-category-box').removeClass('show');
    const targetH = 0;
    $('.js-category-box').eq(nownum).height(targetH);

    $(this).addClass('active');
    setTimeout(function(){
      const targetH = $('.js-category-inner').eq(num).outerHeight(true);
      $('.js-category-box').eq(num).height(targetH);
      $('.js-category-box').eq(num).addClass('show');
    },400);

    setTimeout(function(){
      categoryActive = false;
    },400);

  }
});


$('.js-select-middle').on('change',function(){
  const num = $(this).prop("selectedIndex");
  $(this).next().find('.js-select-small').removeClass('show');
  $(this).next().find('.js-select-small').eq(num).addClass('show');
})
